import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs/internal/Subject';


@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private translate = inject(TranslateService);

	public notify: Subject<{ type: "error" | "success"; message: string; duration?: number }> = new Subject();

	showErrorMessage(message: string, errorDetail = null, duration?: number) {
		let tr: string;
		try {
			tr = this.translate.instant(message);
		} catch (_error) {
			tr = message;
		} finally {
			this.notify.next({type: 'error', message: tr + (errorDetail ? ` (${errorDetail})` : ''), duration: duration});
		}
	}

	showSuccessMessage(message: string, duration?: number) {
		let tr: string;
		try {
			tr = this.translate.instant(message);
		} catch (_error) {
			tr = message;
		} finally {
			this.notify.next({type: 'success', message: tr, duration: duration});
		}
	}

}
